import type { ILegalEntityDTO, IPersonDto } from '@qwealth/qdata';
import type { ContactListItem } from '@qwealth/qvault';

export const buildAllMembers = (clientMembers: IPersonDto[], legalEntities: ILegalEntityDTO[]): ContactListItem[] => [
  ...clientMembers.map(member => ({
    qid: member.QID || '',
    name: `${member.firstName} ${member.lastName}`,
    role: member.householdMembers[0].memberType,
  })),
  ...legalEntities.map(le => ({ qid: le.QID || '', name: le.name, role: 'Legal Entity' })),
];

export const getCheckedMemberQids = (
  allMembers: ContactListItem[],
  relatedMembersChecked: boolean[] | undefined,
): string[] =>
  relatedMembersChecked
    ? allMembers.filter((_, index) => relatedMembersChecked[index]).map(m => m.qid)
    : [];
